// HomeButton.js

import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


const HomeButton = () => {
  const { t } = useTranslation();

  return (
    <Link to="/" className="inline-block px-20 py-2 bg-wild-ocean	font-heading uppercase text-white rounded-md font-semibold hover:bg-green-adventure	 transition-colors">
           {t('buttons.home')}

    </Link>
  );
}

export default HomeButton;
